<template>
  <v-container>
    <v-row dense>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/cultivo" depressed class="primary">
          <v-icon left>mdi-plus</v-icon>
          Agregar siembra
        </v-btn>
      </v-col>
      <v-col cols="12">
        <!-- listado de siembras en el almacenamiento local -->
        <v-list three-line>
          <template v-for="siembra in siembras">
            <form-card
              :key="siembra.ID"
              :top-text="`Finca • ${getNombreDeFinca(siembra.ID_FINCA)}`"
              :bottom-right-text="producerDescription(siembra.productor)"
              :middle-text="`Siembra de ${
                cultivo(siembra.ID_CULTIVO).descripcion
              }`"
              :bottom-text="`Coa ${siembra.COA} , RUC: ${getRucDeFinca(
                siembra.ID_FINCA
              )}`"
              :top-right-text="siembra.FECHA_SIEMBRA"
              :sincronized="siembra.sincronizado"
              @click="traerRegistroYNavegar(siembra)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription, parcelaDescription } from '@/utilidades'

export default {
  name: 'Siembras',
  computed: {
    ...mapState('registros', ['siembras']),
    ...mapGetters('listados', ['cultivo']),
    ...mapGetters('registros', ['getNombreDeFinca', 'getRucDeFinca']),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Siembra')
  },
  methods: {
    producerDescription,
    parcelaDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getSiembra', { id: registro.ID })
      }
      this.$router.push(`/ru/cultivo/${registro.ID}`)
    },
  },
}
</script>
